export const contactsData = {
    email: 'wangruifan1@gmail.com',
    phone: '+1(631-568-3312)',
    address: 'Dallas, Texas',
    github: 'https://github.com/ruw321',
    linkedIn: 'https://www.linkedin.com/in/wang321',
}